import { render, staticRenderFns } from "./AssessmentSection.vue?vue&type=template&id=e3b252d0&"
import script from "./AssessmentSection.vue?vue&type=script&lang=js&"
export * from "./AssessmentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports